module.exports = __webpack_public_path__ + "img/92-Eiche Kolonial - Chêne Dor‚.jpg";